<template>
	<div class="user-info" :style="positionStyle" @click.stop>
		<div class="user-info-box">
			<div class="avatar">
				<head-image :name="user.nickName" :url="user.headImageThumb" :size="60" :online="user.online"
					@click.native="showFullImage()" radius="10%"> </head-image>
			</div>
			<div class="info-card">
				<!-- <div class="header">
					<div class="nick-name">{{ user.nickName }}</div>
					<div v-if="user.sex == 0" class="icon iconfont icon-man" style="color: darkblue;"></div>
					<div v-if="user.sex == 1" class="icon iconfont icon-girl" style="color: darkred;"></div>
				</div>
				<div class="info-item">
					用户名: {{ user.userName }}
				</div>
				<div class="info-item">
					个性签名: {{ user.signature }}
				</div> -->
				<div>
						<div class="real-info" style="margin-top: 16px;">
							<p
								style="width: 300px;margin: 0 auto;text-align: left;font-size: 18px;line-height: 28px;font-weight: 600;margin-bottom: 8px;">
								{{ user.nickName }}</p>
							<p
								style="width: 300px;margin: 0 auto;font-weight: 600;text-align: left;display: flex; align-items: center;font-size: 14px;">
								<img src="@/assets/image/icon_company 1@2x.png" style="width: 18px;height: 18px;margin-right: 4px;"
									alt="">{{ user.orgName }}</p>
						</div>
						<div class="info-item" style="margin: 20px 0;">
							<!-- {{ userInfo }} -->
							<div class="description" :column="1" style="width: 100%;border-top: 1px solid #E8EBF0;border-bottom: 1px solid #E8EBF0;padding:20px 20px 0 0 ;box-sizing: border-box;">
							<div style="text-align: left;font-size: 14px;margin-bottom: 12px;">
								<span style="display: inline-block;width: 80px;color: #9E9E9E;">用户名</span>
								<span style="font-weight: 600;">{{ user.userName }}</span>
							</div>
							<div style="text-align: left;font-size: 14px;margin-bottom: 12px;">
								<span style="display: inline-block;width: 80px;color: #9E9E9E;">性别</span>
								<span style="font-weight: 600;">{{ user.sex == 0 ? "男" : "女" }}</span>
							</div>
							<div style="text-align: left;font-size: 14px;margin-bottom: 20px;">
								<span style="display: inline-block;width: 80px;color: #9E9E9E;">签名</span>
								<span style="font-weight: 600;">{{ user.signature }}</span>
							</div>
							
							
						</div>
						</div>
						<div class="btn-group">
							<!-- <el-button v-show="isFriend"
								@click="onSendMessage(userInfo)">发消息</el-button>
							<el-button v-show="!isFriend" icon="el-icon-plus" type="primary"
								@click="onAddFriend(userInfo)">加为好友</el-button>
							<el-button v-show="isFriend" icon="el-icon-delete" type="danger"
								@click="onDelFriend(userInfo)">删除好友</el-button> -->
							<div class="send-msg-btn" @click="onSendMessage(user)">
								<img src="@/assets/image/icon_messages2@2x.png" alt=""
									style="width: 24px;height: 24px;">
								<span>发消息</span>
							</div>
							<!-- <div class="delete-msg-btn" v-show="isFriend" @click="onDelFriend(user)">
								<img src="@/assets/image/icon_delete@2x.png" alt="" style="width: 24px;height: 24px;">
								<span>删除好友</span>
							</div> -->
							<!-- <div class="send-msg-btn" v-show="!isFriend" @click="onAddFriend(userInfo)">
								<img src="@/assets/image/icon_delete@2x.png" alt="" style="width: 24px;height: 24px;">
								<span>添加好友</span>
							</div> -->
						</div>
					
					</div>
			</div>
		</div>
		<!-- <el-divider content-position="center"></el-divider> -->
		<!-- <div class="btn-group">
			<el-button v-if="isFriend" type="primary" @click="onSendMessage()">发消息</el-button>
			<el-button v-else type="primary" @click="onAddFriend()">加为好友</el-button>
		</div> -->
	</div>
</template>

<script>
import HeadImage from './HeadImage.vue'

export default {
	name: "userInfo",
	components: {
		HeadImage
	},
	data() {
		return {
			dialogVisible:false
		}
	},
	props: {
		user: {
			type: Object
		},
		pos: {
			type: Object
		}
	},
	methods: {
		onSendMessage() {
			let user = this.user;
			let chat = {
				type: 'PRIVATE',
				targetId: user.id,
				showName: user.nickName,
				headImage: user.headImage,
			};
			this.$store.commit("openChat", chat);
			this.$store.commit("activeChat", 0);
			if (this.$route.path != "/home/chat") {
				this.$router.push("/home/chat");
			}
			this.$emit("close");
		},
		onAddFriend() {
			this.$http({
				url: "/friend/add",
				method: "post",
				params: {
					friendId: this.user.id
				}
			}).then(() => {
				this.$message.success("添加成功，对方已成为您的好友");
				let friend = {
					id: this.user.id,
					nickName: this.user.nickName,
					headImage: this.user.headImageThumb,
					online: this.user.online,
					deleted: false
				}
				this.$store.commit("addFriend", friend);
			})
		},
		showFullImage() {
			if (this.user.headImage) {
				this.$store.commit("showFullImageBox", this.user.headImage);
				this.$store.commit('closeUserInfoBox')
			}
		}
	},
	computed: {
		isFriend() {
			return this.$store.getters.isFriend(this.user.id);
		},
		positionStyle() {
			return {
				left: this.pos.x + 'px',
				top: this.pos.y + 'px'
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.user-info {
	position: fixed;
	width: 300px;
	background-color: white;
	box-shadow: var(--im-box-shadow);
	border-radius: 4px;
	padding: 15px;
	z-index: 9999;

	.user-info-box {
		// display: flex;
		// align-items: center;

		.info-card {
			flex: 1;
			padding-left: 10px;

			.header {
				display: flex;
				align-items: center;

				.nick-name {
					font-size: var(--im-font-size-large);
					font-weight: 600;
				}

				.icon {
					margin-left: 3px;
					font-size: var(--im-font-size);
				}
			}

			.info-item {
				font-size: var(--im-font-size);
				margin-top: 5px;
				word-break: break-all;
			}
		}
	}

	.el-divider--horizontal {
		margin: 18px 0;
	}

	.btn-group {
		text-align: center;
	}
	.send-msg-btn {
				display: inline-block;
				text-align: center;
				// margin-right: 80px;
				padding: 8px 23px;
				border-radius: 8px;
				&:hover {
					background-color: #f2f2f2;
				}
				img {
					display: block;
					margin: 0 auto;
					margin-bottom: 12px;
				}

				span {
					font-family: PingFang SC, PingFang SC;
					font-weight: 400;
					font-size: 14px;
					color: #027AFF;
					line-height: 22px;
					text-align: center;
					font-style: normal;
					text-transform: none;
				}
			}

}
</style>